import { render, staticRenderFns } from "./CodeWithQrForm.vue?vue&type=template&id=4c0c6972&scoped=true&"
import script from "./CodeWithQrForm.vue?vue&type=script&lang=js&"
export * from "./CodeWithQrForm.vue?vue&type=script&lang=js&"
import style0 from "./CodeWithQrForm.vue?vue&type=style&index=0&id=4c0c6972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c6972",
  null
  
)

export default component.exports